module.exports = __webpack_public_path__ + "static/media/dauraMarzen.45a071e3.jpg";